<!-- @format -->

<div class="modal-overlay">
  <div class="modal-body">
    <span class="title">
      <img src="../../../assets/red-warning.svg" alt="warning icon" />
      Submission Warning
    </span>
    <div class="message">
      <p>{{ message }}</p>
    </div>
    <div *ngIf="isAcknowledgedType" class="acknowledge-row">
      <label class="ack-label">
        <input type="checkbox" [(ngModel)]="isAcknowledged" />
        <span>I confirm I have reviewed this submission</span>
      </label>
    </div>
    <div class="actions">
      <button class="btn-outline" (click)="goBack()" type="button">
        Go Back
      </button>
      <button
        class="btn-fill-yellow"
        (click)="proceed()"
        [disabled]="proceedDisabled"
        type="button">
        {{ isAcknowledgedType ? 'Proceed' : 'Proceed Anyway' }}
      </button>
    </div>
  </div>
</div>
